// extracted by mini-css-extract-plugin
export default {"logoHelvetia":"loginHeading_logoHelvetia__v4j05","mainText":"loginHeading_mainText__ogF5s"};